const cards = [
  "😄",
  "😉",
  "😍",
  "😘",
  "😂",
  "😭",
  "👮",
  "😈",
  "👹",
  "👺",
  "👽",
  "💩",
  "🔥",
  "🎩",
  "👑",
  "👠",
  "👙",
  "💼",
  "🌂",
  "💄",
  "💍",
  "🐰",
  "🐒",
  "🐴",
  "🐑",
  "🐢",
  "🐛",
  "🐝",
  "🐬",
  "🐳",
  "🌸",
  "🌻",
  "🌓",
  "🌏",
  "🌋",
  "⛄",
  "🌈",
  "🎓",
  "🎃",
  "👻",
  "💾",
  "💻",
  "📡",
  "📣",
  "⏳",
  "🔓",
  "🔦",
  "🔆",
  "🎾",
  "🎱",
  "🏀",
  "⚽",
  "🍕",
  "🍔",
  "🍟",
  "🍷",
  "🍻",
  "🍩",
  "🍮",
  "🍦",
  "🍇",
  "🍉",
  "🍓",
  "🍌",
  "🍐",
  "🍍",
  "🚁",
  "🚂",
  "🚃",
];

export default cards;
